import { LoadingButton } from '@mui/lab';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import UserApiService from 'api/UserApiService';
import { WarningIcon } from 'components/CustomIcons';
import useApi from 'hooks/useApi';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { closeDialogAction } from 'store/actions/dialogsActions';
import { setSnackbarAction } from 'store/actions/snackbarActions';
import { useSelector } from 'store/hooks';
import { useAppState } from 'store/Provider';
import User from 'types/entities/User';

type ClientsDialogResetPasswordProps = {
  activeUser: User;
};

const ClientsDialogResetPassword: React.FC<ClientsDialogResetPasswordProps> = ({ activeUser }) => {
  const [t] = useTranslation();
  const dialogs = useSelector((state) => state.dialogs);
  const [loading, setLoading] = useState(false);
  const { dispatch } = useAppState();
  const { makeCall } = useApi();
  const close = () => {
    dispatch(closeDialogAction('clientResetPassword'));
  };

  const resetPassword = async () => {
    setLoading(true);
    const res = await makeCall(UserApiService.resetPassword(activeUser.id), 'Error resetting password');
    if (res) {
      dispatch(setSnackbarAction({ message: 'Password reset successfully', open: true, severity: 'success' }));
      dispatch(closeDialogAction('clientResetPassword'));
    }
    setLoading(false);
  };

  return (
    <>
      <Dialog style={{ maxHeight: 435 }} maxWidth="sm" open={dialogs.clientResetPassword || false}>
        <DialogTitle>{t('Reset_Password')}</DialogTitle>
        <DialogContent>
          <div>{t('Confirm_Client_Reset_Password')}</div>
          <Stack direction="row" sx={{ alignItems: 'center', gap: 1, mt: 2 }}>
            <WarningIcon color="error" />
            <Typography color="error">{t('Remember_Check_Spams')}</Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="primary" onClick={close}>
            {t('Cancel')}
          </Button>
          <Button variant="contained" loading={loading} onClick={resetPassword} color="primary">
            {t('Confirm_Reset_Password')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ClientsDialogResetPassword;
